import { styled, Tooltip } from "@mui/material";
import React, { ReactElement, ReactNode } from "react";
import { useDrawingArea } from "@mui/x-charts-premium";
import { ConditionalWrap } from "shared-ts-ui-react";

const StyledText = styled("text")(({ theme, fontSize }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: fontSize ?? 20,
}));

export interface PieCenterLabelProps {
  children: ReactNode;
  fontSize?: number | string;
  tooltip?: string;
}

export const PieCenterLabel = (props: PieCenterLabelProps) => {
  const { fontSize } = props;
  const { width, height, left, top } = useDrawingArea();
  return (
    <ConditionalWrap
      condition={props.tooltip != null}
      wrap={(children) => (
        <Tooltip title={props.tooltip}>{children as ReactElement}</Tooltip>
      )}
    >
      <StyledText x={left + width / 2} y={top + height / 2} fontSize={fontSize}>
        {props.children}
      </StyledText>
    </ConditionalWrap>
  );
};
